<template>


  <div>
    <!-- <VueOfficeExcel :src="path" v-if="path.endsWith('.xlsx') || path.endsWith('.xls')"/> -->
    <!-- <VueOfficeDocx :src="path" v-if="path.endsWith('.doc') || path.endsWith('.docx')"/> -->
    <!-- <office-viewer :url="path"></office-viewer> -->
    <vueOfficePdf :src="path" v-if="path.endsWith('.pdf')"/>
    <iframe
      v-else
      :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(path)"
      width="100%"
      style="height: calc(100vh - 120px)"
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
// import pdf from 'vue-pdf'
import VueOfficePdf from '@vue-office/pdf'
import VueOfficeDocx from '@vue-office/docx'
import VueOfficeExcel from '@vue-office/excel'
// import OfficeViewer from 'vue-office-viewer';
import '@vue-office/docx/lib/index.css'

export default {
  components: { VueOfficeDocx,VueOfficeExcel,VueOfficePdf },
  data() {
    return { };
  },
  props: {
    path: {
      type: String,
      default: undefined,
    },
  },
  mounted() {

  },
  methods: {

  },
  watch:{

  }
};
</script>
<!-- vue-office-excel -->
<style lang="less" scoped>
  .vue-office-excel {
    background: #fff;
  }
</style>